// istanbul ignore file
import { Card, CircularProgress, Grid, Typography, Checkbox, Box, TextField, IconButton } from '@mui/material'
import React, { useRef } from 'react'
import '../../device-dashboard/components/dashboard.css'
import HighchartsReact from 'highcharts-react-official'
import DarkUnica from 'highcharts/themes/dark-unica'
import * as HighCharts from 'highcharts'
import { GenXDropdown, type Option } from '../../../components/GenXDropdown'
import { getFlowRegisterService, getFlowKPIService } from '../redux/actionCreator'
import { type flowSignalReadingAssetDataState } from '../redux/getFlowSignaGraphDataSlice'
import { type GetDefaultWidgetDataState } from '../../device-dashboard/redux/getSaveDefaultViewServiceSlice'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { type RootState } from '../../../store'
import { flowKPIGraphDataLoadingAction, type flowKPIAssetDataState } from '../../asset-dashboard/redux/getFlowKPIDataSlice'
import { flowRegisterGraphDataLoadingAction, type flowRegisterAssetDataState } from '../../asset-dashboard/redux/getFlowRegisterDataSlice'
import extentWindow from '../../../assets/extendClick.svg'
import dayjs from 'dayjs'
import AuthError from '../../../components/ErrorComponents/AuthError'
import utc from 'dayjs/plugin/utc'
import Modal from '../../../components/Modal'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '../../../assets/Edit.svg'
import { useLocation, useOutletContext } from 'react-router-dom'
import { updateSaveDefaultObject } from '../../../utils/updateSaveDefaultObject'
import { getFlameSignalDataOptionsNew, type IConfigObject } from '../components/ChartOptions'
import { MemorizedExport } from '../../services/components/ExportGraphData'
import { DEFAULT_DATA_WINDOW_HOURS } from '../../../utils/DashboardContants'
import { APIConfiguration } from '../../../utils/apiConfiguration'
import { getSaveDeafaultWidget } from '../../device-dashboard/redux/actionCreator'

dayjs.extend(utc)

const defaultConfigObj: IConfigObject = {
  1: {
    serialNumber: '1',
    checked: false,
    color: '#9AB7FF',
    selectedSignalData: null,
    isDeviceKPI: false,
    isAssetKPI: false,
    selectedDeviceAssetID: '',
    index: 1
  },
  2: {
    serialNumber: '2',
    checked: false,
    color: '#FFF55D',
    selectedSignalData: null,
    isDeviceKPI: false,
    isAssetKPI: false,
    selectedDeviceAssetID: '',
    index: 2
  },
  3: {
    serialNumber: '3',
    checked: false,
    color: '#f2752c',
    selectedSignalData: null,
    isDeviceKPI: false,
    isAssetKPI: false,
    selectedDeviceAssetID: '',
    index: 3
  },
  4: {
    serialNumber: '4',
    checked: false,
    color: '#19CB35',
    selectedSignalData: null,
    isDeviceKPI: false,
    isAssetKPI: false,
    selectedDeviceAssetID: '',
    index: 4
  }
}

const fuelFlowGraph = (props: AllProps): JSX.Element => {
  const [showAddModal, setShowAddModal] = React.useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [signalOptions, setSignalOptions] = React.useState<Option[]>([])
  const [signalOptions1, setSignalOptions1] = React.useState<Option[]>([])
  const [signalOptions2, setSignalOptions2] = React.useState<Option[]>([])
  const [signalOptions3, setSignalOptions3] = React.useState<Option[]>([])
  const [signalOptions4, setSignalOptions4] = React.useState<Option[]>([])
  const [signalData1, setSignalData1] = React.useState<Option | null>(null)
  const [signalData2, setSignalData2] = React.useState<Option | null>(null)
  const [signalData3, setSignalData3] = React.useState<Option | null>(null)
  const [signalData4, setSignalData4] = React.useState<Option | null>(null)
  const [isAssetLevelKPIEnabled1, setAssetLevelKPIEnabled1] = React.useState(false)
  const [isAssetLevelKPIEnabled2, setAssetLevelKPIEnabled2] = React.useState(false)
  const [isAssetLevelKPIEnabled3, setAssetLevelKPIEnabled3] = React.useState(false)
  const [isAssetLevelKPIEnabled4, setAssetLevelKPIEnabled4] = React.useState(false)
  const [isDefaultDataLoading, setIsDefaultDataLoading] = React.useState(true)
  const colors: string[] = ['#9AB7FF', '#FFF55D', '#f2752c', '#19CB35']
  const flowSignalDataStatus = useSelector((state: RootState) => state.flowRegisterData.flowRegisterAssetData)
  const flowSignalKPIDataStatus = useSelector((state: RootState) => state.flowKPIAssetData.flowKPIAssetData)
  const flowSignalHttpStatus = useSelector((state: RootState) => state.flowRegisterData)
  const flowSignalHttpKPIStatus = useSelector((state: RootState) => state.flowKPIAssetData)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dropDownArray, setdropDownArray] = React.useState<any>([])
  const [selectedDevice, setSelectedDevice] = React.useState<Option | null>(null)
  const [selectedDevice1, setSelectedDevice1] = React.useState<Option | null>(null)
  const [selectedDevice2, setSelectedDevice2] = React.useState<Option | null>(null)
  const [selectedDevice3, setSelectedDevice3] = React.useState<Option | null>(null)
  const [selectedDeviceOptions, setselectedDeviceOptions] = React.useState<Option[]>([])
  const [loading, setLoading] = React.useState(false)
  const saveDefaultStatus = useSelector((state: RootState) => state.SaveDefaultViewData)
  const [showSuccessPopUp, setshowSuccessPopUp] = React.useState(false)
  const deviceManagementDeviceList = useSelector((state: RootState) => state.DeviceListData?.DeviceListData)
  const [isEditing, setIsEditing] = React.useState(false)
  const [isDefaultDataLoaded, setIsDefaultDataLoaded] = React.useState(false)
  const [text, setText] = React.useState('Graph2')
  const saveDefaultViewObject = useSelector((state: RootState) => state.saveDefaultViewObject.saveDefaultViewObject)
  const selectedData = React.useRef<any>(null)
  const stateLocation = useLocation()
  const [assetKPIOptions, setAssetKPIOptions] = React.useState<Option[]>([])
  const [configObject, setConfigObject] = React.useState(defaultConfigObj)
  const [chartOptions, setChartOptions] = React.useState<any>({})
  const [graphDefaultSelectedIds, setGraphDefaultSelectedIds] = React.useState<any>([])
  const chartComponentRef = React.useRef<any>(null)
  const chartComponentRef1 = React.useRef<any>(null)
  const { sidebarCollapsed } = useOutletContext<{ sidebarCollapsed: boolean }>() ?? { sidebarCollapsed: false }
  /* Selected KPI */
  const [selectedKPI1, setSelectedKPI1] = React.useState<Option | null>(configObject[1].isAssetKPI ? { value: 'assetLevel', label: 'Asset Level' } : { value: 'deviceLevel', label: 'Device Level' })
  const [selectedKPI2, setSelectedKPI2] = React.useState<Option | null>(configObject[2].isAssetKPI ? { value: 'assetLevel', label: 'Asset Level' } : { value: 'deviceLevel', label: 'Device Level' })
  const [selectedKPI3, setSelectedKPI3] = React.useState<Option | null>(configObject[3].isAssetKPI ? { value: 'assetLevel', label: 'Asset Level' } : { value: 'deviceLevel', label: 'Device Level' })
  const [selectedKPI4, setSelectedKPI4] = React.useState<Option | null>(configObject[4].isAssetKPI ? { value: 'assetLevel', label: 'Asset Level' } : { value: 'deviceLevel', label: 'Device Level' })
  const [selectedKPIOptions] = React.useState<Option[]>([
    { value: 'deviceLevel', label: 'Device Level' },
    { value: 'assetLevel', label: 'Asset Level' }
  ])
  const dashboardHours = DEFAULT_DATA_WINDOW_HOURS

  // Reflow chart when sidebar state changes
  React.useEffect(() => {
    // Wait for DOM/layout changes before reflow
    setTimeout(() => {
      const chart = chartComponentRef.current?.chart
      if (chart !== null && chart !== undefined) {
        chart.reflow()
      }
    }, 450) // Slightly increased delay for smoother sidebar animation
  }, [sidebarCollapsed])

  React.useEffect(() => {
    return () => {
      // This function runs when the component unmounts
      props.resetFuelService()
    }
  }, [])

  React.useEffect(() => {
    chartComponentRef.current?.chart?.reflow()
  }, [chartComponentRef.current, showAddModal])

  React.useEffect(() => {
    chartComponentRef1.current?.chart?.reflow()
  }, [chartComponentRef1.current, showAddModal])

  const formattedResponseKPIRef = useRef<any>()
  interface StateLocation {
    parentSiteId: string
    parentAssetId: string
  }

  const defaultParam = JSON.stringify({
    assetId: props.parentAssetId,
    devices: []
  })

  const defaultParamKPI = JSON.stringify({
    assetId: props.parentAssetId,
    devices: [],
    assets: []
  })

  const getUtcDateRange = (): { today: string, defaultDataWindowUTC: string } => {
    const utcDate = dayjs()
    const today = utcDate.utc().format('YYYY-MM-DD HH:mm:ss')
    const defaultDataWindowUTC = utcDate.utc().subtract(dashboardHours, 'hour').format('YYYY-MM-DD HH:mm:ss')
    return { today, defaultDataWindowUTC }
  }
  const { today, defaultDataWindowUTC } = getUtcDateRange()
  const navigateState = stateLocation.state as StateLocation | null
  const parentSiteId = navigateState != null ? navigateState.parentSiteId : ''
  const parentAssetId = navigateState != null ? navigateState.parentAssetId : ''
  const GetDeviceParameters = useSelector((state: RootState) => state.getParameterConfigurationData)

  React.useEffect(() => {
    if (!GetDeviceParameters.isLoading) {
      const assetKPIOptions: Option[] = []
      GetDeviceParameters?.parameters?.assetKPIs?.forEach((kpi: any) => {
        assetKPIOptions.push({
          value: kpi.kpiDefinitionId,
          label: kpi.parameterName,
          unit: kpi.unit,
          isAssetKPI: true
        })
      })
      setAssetKPIOptions(assetKPIOptions)
      if (typeof props.saveDefaultWidgetData?.DefaultWidgetData !== 'undefined' && props.saveDefaultWidgetData?.DefaultWidgetData !== null) {
        getCimCode1(props.saveDefaultWidgetData?.DefaultWidgetData, 'assetGraph2')
      }
    }
  }, [GetDeviceParameters.parameters, props.saveDefaultWidgetData?.DefaultWidgetData])

  React.useEffect(() => {
    if (!isDefaultDataLoading) return
    graphDefaultSelectedIds.forEach((cimCode: any, index: number) => {
      let selectedDevice = null

      if (index === 0) {
        selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
        if (cimCode.Device === true && selectedDevice !== undefined) {
          handleDeviceSelectionFirstClick(selectedDevice)
        } else if (cimCode.Device === false) {
          setAssetLevelKPIEnabled1(true)
        }
      } else if (index === 1) {
        selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
        if (cimCode.Device === true && selectedDevice !== undefined) {
          handleDeviceSelectionSecondClick(selectedDevice)
        } else if (cimCode.Device === false) {
          setAssetLevelKPIEnabled2(true)
        }
      } else if (index === 2) {
        selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
        if (cimCode.Device === true && selectedDevice !== undefined) {
          handleDeviceSelectionThirdClick(selectedDevice)
        } else if (cimCode.Device === false) {
          setAssetLevelKPIEnabled3(true)
        }
      } else if (index === 3) {
        selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
        if (cimCode.Device === true && selectedDevice !== undefined) {
          handleDeviceSelectionForthClick(selectedDevice)
        } else if (cimCode.Device === false) {
          setAssetLevelKPIEnabled4(true)
        }
      }
    })
  }, [graphDefaultSelectedIds])

  React.useEffect(() => {
    const newConfigObject = { ...configObject }
    if (graphDefaultSelectedIds.length > 0 && isDefaultDataLoading) {
      graphDefaultSelectedIds.forEach((cimCode: any, index: number) => {
        let match = null
        let selectedDevice = null

        if (index === 0) {
          selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
          match = cimCode.Device === true
            ? configObject[1].selectedSignalData ?? signalOptions1.find(item => item.value === cimCode.cimCodeId || item.value === cimCode.kpiId)
            : configObject[1].selectedSignalData ?? assetKPIOptions.find(item => item.value === cimCode.kpiId)
        } else if (index === 1) {
          selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
          match = cimCode.Device === true
            ? configObject[2].selectedSignalData ?? signalOptions2.find(item => item.value === cimCode.cimCodeId || item.value === cimCode.kpiId)
            : configObject[2].selectedSignalData ?? assetKPIOptions.find(item => item.value === cimCode.kpiId)
        } else if (index === 2) {
          selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
          match = cimCode.Device === true
            ? configObject[3].selectedSignalData ?? signalOptions3.find(item => item.value === cimCode.cimCodeId || item.value === cimCode.kpiId)
            : configObject[3].selectedSignalData ?? assetKPIOptions.find(item => item.value === cimCode.kpiId)
        } else if (index === 3) {
          selectedDevice = selectedDeviceOptions.find(item => item.value === cimCode.id)
          match = cimCode.Device === true
            ? configObject[4].selectedSignalData ?? signalOptions4.find(item => item.value === cimCode.cimCodeId || item.value === cimCode.kpiId)
            : configObject[4].selectedSignalData ?? assetKPIOptions.find(item => item.value === cimCode.kpiId)
        }

        if (match != null && !isDefaultDataLoaded) {
          newConfigObject[index + 1] = {
            ...newConfigObject[index + 1],
            selectedSignalData: match,
            selectedDeviceAssetID: match.isAssetKPI === true ? props.parentAssetId : selectedDevice?.value ?? '',
            checked: true,
            isDeviceKPI: match.isKPI !== undefined ? match.isKPI : false,
            isAssetKPI: match.isAssetKPI !== undefined ? match.isAssetKPI : false
          }
        }
      })
      setConfigObject(newConfigObject)
    }

    Object.keys(newConfigObject).forEach(key => {
      if (newConfigObject[Number(key)]?.isAssetKPI) {
        switch (key) {
          case '1':
            setSelectedKPI1({ value: 'assetLevel', label: 'Asset Level' })
            break
          case '2':
            setSelectedKPI2({ value: 'assetLevel', label: 'Asset Level' })
            break
          case '3':
            setSelectedKPI3({ value: 'assetLevel', label: 'Asset Level' })
            break
          case '4':
            setSelectedKPI4({ value: 'assetLevel', label: 'Asset Level' })
            break
        }
      }
    })
  }, [graphDefaultSelectedIds, signalOptions1, signalOptions2, signalOptions3, signalOptions4, assetKPIOptions, selectedDeviceOptions, props.parentAssetId])

  React.useEffect(() => {
    if (!props.flowRegisterData.isLoading && !props.flowKPIAssetData.isLoading && props.saveDefaultWidgetData.httpStatus === APIConfiguration.SUCCESS_HTTP_STATUS) {
      const mergedData = [
        ...(Array.isArray(flowSignalDataStatus) ? flowSignalDataStatus?.filter(elem => elem.registerReadings?.length > 0) : []),
        ...(((flowSignalKPIDataStatus?.deviceKPIReadings) != null) && Array.isArray(flowSignalKPIDataStatus?.deviceKPIReadings) ? flowSignalKPIDataStatus?.deviceKPIReadings?.filter(elem => elem.kpiReadings.length > 0) : []),
        ...(((flowSignalKPIDataStatus?.assetKPIReadings) != null) && Array.isArray(flowSignalKPIDataStatus?.assetKPIReadings) ? flowSignalKPIDataStatus?.assetKPIReadings?.filter(elem => elem.kpiReadings.length > 0) : [])
      ]
      const options = getFlameSignalDataOptionsNew(mergedData, configObject)
      if ((options?.series ?? [])?.length > 0) { setChartOptions(options) }
      setLoading(false)
    }
    console.log('sing', signalData1, signalData2, signalData3, signalData4)
  }, [props.flowRegisterData, props.flowKPIAssetData, configObject])

  React.useEffect(() => {
    if (!props.IsGolive && props.startDate !== '' && props.endDate !== '' && configObject !== defaultConfigObj) {
      fetchDataForSelection(configObject)
    }
  }, [props.startDate, props.endDate])

  const resetForm = (): void => {
    // Reset data when changed asset
    setConfigObject(defaultConfigObj)
    setSelectedKPI1({ value: 'deviceLevel', label: 'Device Level' })
    setSelectedKPI2({ value: 'deviceLevel', label: 'Device Level' })
    setSelectedKPI3({ value: 'deviceLevel', label: 'Device Level' })
    setSelectedKPI4({ value: 'deviceLevel', label: 'Device Level' })

    setSignalOptions1([])
    setSignalOptions2([])
    setSignalOptions3([])
    setSignalOptions4([])

    setSignalData1(null)
    setSignalData2(null)
    setSignalData3(null)
    setSignalData4(null)

    setAssetKPIOptions([])
    setGraphDefaultSelectedIds([])

    setAssetLevelKPIEnabled1(false)
    setAssetLevelKPIEnabled2(false)
    setAssetLevelKPIEnabled3(false)
    setAssetLevelKPIEnabled4(false)

    setSelectedDevice(null)
    setSelectedDevice1(null)
    setSelectedDevice2(null)
    setSelectedDevice3(null)

    setIsDefaultDataLoaded(false)
    setIsDefaultDataLoading(true)
    formattedResponseKPIRef.current = null
  }
  const refreshScreen = (): void => {
    if (props.IsGolive) {
      resetForm()
      const { today, defaultDataWindowUTC } = getUtcDateRange()
      props.getFlowRegisterService(defaultDataWindowUTC, today, 'assetGraph2', defaultParam, true)
      props.getFlowKPIService(defaultDataWindowUTC, today, 'assetGraph2', defaultParamKPI, true)
    }
    setChartOptions(getFlameSignalDataOptionsNew([], configObject))
  }

  React.useEffect(() => {
    refreshScreen()
  }, [props.parentAssetId])

  const RetryModel = React.memo(function RetryModel (props: AllProps) {
    return <>
         <div className='CircularprogressAmi' style={{ position: 'relative', height: '265px' }}>
      <div style={{ textAlign: 'center', width: '325px' }}>
        <AuthError
          className="paramterError graphError"
          errorMessage="cannotFetch"
          retry= {() => {
            props.getSaveDeafaultWidget(props.parentSiteId, props.parentAssetId, props.parentAssetId)
            props.getFlowRegisterService(
              props.startDate,
              props.endDate,
              'assetGraph2',
              JSON.stringify({
                assetId: props.parentAssetId,
                devices: []
              }),
              true
            )
            props.getFlowKPIService(
              props.startDate,
              props.endDate,
              'assetGraph2',
              JSON.stringify({
                assetId: props.parentAssetId,
                devices: [],
                assets: []
              }),
              true
            )
          }}
        />
      </div>
    </div>
      </>
  })

  const getSignalGraph = (index: number): JSX.Element => {
    const isLoading = flowSignalHttpStatus.isLoading || flowSignalHttpKPIStatus.isLoading
    const isUnauthorized = flowSignalHttpStatus.httpStatus === 401
    const isForbidden = flowSignalHttpStatus.httpStatus === 403
    const isInvalidDateRange =
    flowSignalHttpStatus.errorMessage === 'Invalid Date Range' &&
    flowSignalHttpStatus.httpStatus === 400
    const isNoParameterSelection =
    flowSignalHttpStatus.httpStatus === 204 &&
    flowSignalHttpKPIStatus.httpStatus === 204
    const isNoDefaultData =
    flowSignalHttpStatus.httpStatus === 404 &&
    flowSignalHttpKPIStatus.httpStatus === 404
    const isSuccess =
    flowSignalHttpStatus.httpStatus === 200 ||
    flowSignalHttpKPIStatus.httpStatus === 200
    const isTimeout =
    flowSignalHttpStatus.httpStatus === APIConfiguration.REQUEST_TIMEOUT ||
    flowSignalHttpKPIStatus.httpStatus === APIConfiguration.REQUEST_TIMEOUT ||
     (props.saveDefaultWidgetData.httpStatus !== APIConfiguration.SUCCESS_HTTP_STATUS &&
        props.saveDefaultWidgetData.httpStatus !== 0
     )

    // ✅ Prioritize loading state
    if (isLoading) {
      return (
      <div className='CircularprogressAmi' style={{ position: 'relative', height: '250px' }}>
        <CircularProgress />
      </div>
      )
    }

    if (isUnauthorized) {
      return (
      <div className='authError flameGraph'>
        <AuthError errorMessage="Unauthorized" />
      </div>
      )
    }

    if (isForbidden) {
      return (
      <div className='authError flameGraph'>
        <AuthError errorMessage="accessForbidden" />
      </div>
      )
    }

    if (isInvalidDateRange) {
      return (
      <div className='authError flameGraph date-invalid'>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <span>Invalid Date Range</span>
        </div>
      </div>
      )
    }

    if (isNoParameterSelection) {
      return (
      <div className='authError flameGraph date-invalid'>
        <AuthError errorMessage="NoParameterSelection" />
      </div>
      )
    }

    if (isNoDefaultData) {
      return (
      <div className='authError flameGraph date-invalid'>
        <AuthError errorMessage="NoDefaultDataPresentGraph" />
      </div>
      )
    }
    if (isTimeout) {
      return (<RetryModel {...props} />)
    }
    if (isSuccess) {
      return (
      <HighchartsReact
        highcharts={HighCharts}
        options={chartOptions}
        ref={index === 0 ? chartComponentRef : chartComponentRef1}
      />
      )
    }

    // ✅ Final fallback with Retry button
    return (
      <RetryModel {...props} />
    )
  }

  React.useEffect(() => {
    if (deviceManagementDeviceList !== undefined && deviceManagementDeviceList !== null && parentSiteId !== null && parentAssetId !== null) {
      const deviceOption: Option[] = []
      deviceManagementDeviceList?.forEach((item: any) => {
        deviceOption.push({
          value: item.id,
          label: item.name,
          unit: item.deviceTypeId
        })
      })
      setselectedDeviceOptions(deviceOption)
    } else {
      setselectedDeviceOptions([])
    }
  }, [deviceManagementDeviceList, parentAssetId])

  const setDisplayname = (data: any, widgetId: string): void => {
    for (const widget of data.assetDashBoardDefaultView) {
      if (widget.widgetId === widgetId) {
        setText(widget.displayname)
        break
      }
    }
  }

  React.useEffect(() => {
    if (typeof props.saveDefaultWidgetData?.DefaultWidgetData !== 'undefined' && props.saveDefaultWidgetData?.DefaultWidgetData !== null) {
      setDisplayname(props.saveDefaultWidgetData?.DefaultWidgetData, 'assetGraph2')
      getCimCode1(props.saveDefaultWidgetData?.DefaultWidgetData, 'assetGraph2')
    }
  }, [props.saveDefaultWidgetData?.DefaultWidgetData])

  const handleKPIClickFirst = (selectedOption: Option): void => {
    const indx = '1'
    const canFetchData = (configObject[indx].selectedSignalData != null)
    const newConfigObject = { ...configObject }
    if (selectedOption.value === 'deviceLevel') {
      newConfigObject[indx].isAssetKPI = false
      setConfigObject(newConfigObject)
    }
    setSelectedKPI1(selectedOption)
    if (selectedOption.value === 'assetLevel') {
      setAssetLevelKPIEnabled1(true)
      setSignalData1(null)
      setSelectedDevice(null)
    } else {
      setAssetLevelKPIEnabled1(false)
      setSelectedDevice(null)
      setSignalData1(null)
    }
    newConfigObject[indx] = {
      ...newConfigObject[indx],
      selectedSignalData: null,
      checked: false
    }
    setConfigObject(newConfigObject)
    setSignalOptions1([])
    if (canFetchData) fetchDataForSelection(newConfigObject)
  }

  const handleKPIClickSecond = (selectedOption: Option): void => {
    const indx = '2'
    const canFetchData = (configObject[indx].selectedSignalData != null)
    const newConfigObject = { ...configObject }
    if (selectedOption.value === 'deviceLevel') {
      newConfigObject[indx].isAssetKPI = false
      setConfigObject(newConfigObject)
    }
    setSelectedKPI2(selectedOption)
    if (selectedOption.value === 'assetLevel') {
      setAssetLevelKPIEnabled2(true)
      setSignalData2(null)
      setSelectedDevice1(null)
    } else {
      setAssetLevelKPIEnabled2(false)
      setSelectedDevice1(null)
      setSignalData2(null)
    }
    newConfigObject[indx] = {
      ...newConfigObject[indx],
      selectedSignalData: null,
      checked: false
    }
    setConfigObject(newConfigObject)
    setSignalOptions2([])
    if (canFetchData) fetchDataForSelection(newConfigObject)
  }

  const handleKPIClickThird = (selectedOption: Option): void => {
    const indx = '3'
    const canFetchData = (configObject[indx].selectedSignalData != null)
    const newConfigObject = { ...configObject }
    if (selectedOption.value === 'deviceLevel') {
      newConfigObject[indx].isAssetKPI = false
      setConfigObject(newConfigObject)
    }
    setSelectedKPI3(selectedOption)
    if (selectedOption.value === 'assetLevel') {
      setAssetLevelKPIEnabled3(true)
      setSignalData3(null)
      setSelectedDevice2(null)
    } else {
      setAssetLevelKPIEnabled3(false)
      setSelectedDevice2(null)
      setSignalData3(null)
    }
    newConfigObject[indx] = {
      ...newConfigObject[indx],
      selectedSignalData: null,
      checked: false
    }
    setConfigObject(newConfigObject)
    setSignalOptions3([])
    if (canFetchData) fetchDataForSelection(newConfigObject)
  }

  const handleKPIClickFourth = (selectedOption: Option): void => {
    const indx = '4'
    const canFetchData = (configObject[indx].selectedSignalData != null)
    const newConfigObject = { ...configObject }
    if (selectedOption.value === 'deviceLevel') {
      newConfigObject[indx].isAssetKPI = false
      setConfigObject(newConfigObject)
    }
    setSelectedKPI4(selectedOption)
    if (selectedOption.value === 'assetLevel') {
      setAssetLevelKPIEnabled4(true)
      setSignalData4(null)
      setSelectedDevice3(null)
    } else {
      setAssetLevelKPIEnabled4(false)
      setSelectedDevice3(null)
      setSignalData4(null)
    }
    newConfigObject[indx] = {
      ...newConfigObject[indx],
      selectedSignalData: null,
      checked: false
    }
    setConfigObject(newConfigObject)
    setSignalOptions4([])
    if (canFetchData) fetchDataForSelection(newConfigObject)
  }
  const resetSignalData = (prevSelectedValue: Option | null, selectedValue: Option, index: number): void => {
    const canFetchData = (configObject[index].selectedSignalData != null)
    setIsDefaultDataLoaded(true) // For preventing to apply default data
    setIsDefaultDataLoading(false) // For preventing to apply default data
    if (prevSelectedValue !== selectedValue) {
      // Deep copy configObject to avoid mutating nested objects
      const newConfigObject = JSON.parse(JSON.stringify(configObject))
      newConfigObject[index] = {
        ...newConfigObject[index],
        selectedSignalData: null,
        checked: false
      }
      setConfigObject(newConfigObject)
      if (canFetchData) fetchDataForSelection(newConfigObject)
    }
  }
  const handleDeviceSelectionFirstClick = (selectedValue: Option): void => {
    setAssetLevelKPIEnabled1(false)
    setSelectedDevice(selectedValue)
    setSignalData1(null)
    const currentDevice = GetDeviceParameters?.parameters?.gateway?.[0]?.device?.filter((d) => d.id === selectedValue.value)?.[0]
    const deviceParamsPromise = currentDevice?.registers ?? []
    const kpiParamsPromise = currentDevice?.kpis ?? []

    Promise.all([deviceParamsPromise, kpiParamsPromise])
      .then(([deviceParamsRes, kpiParamsRes]: any[]) => {
        const assetTypeId = deviceParamsRes
        const standardKPIs = kpiParamsRes
        const kpiParams = [...standardKPIs]

        const signalOptions1: Option[] = []

        assetTypeId.forEach((item: any) => {
          signalOptions1.push({
            value: item.cimCodeId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: false
          })
        })

        kpiParams.forEach((item: any) => {
          signalOptions1.push({
            value: item.kpiDefinitionId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: true
          })
        })

        setSignalOptions1(signalOptions1)
      })
      .catch((res: any) => {
        // Handle error
      })
  }

  const handleDeviceSelectionSecondClick = (selectedValue: Option): void => {
    setAssetLevelKPIEnabled2(false)
    setSelectedDevice1(selectedValue)
    setSignalData2(null)
    setSignalOptions2([])
    const currentDevice = GetDeviceParameters?.parameters?.gateway?.[0]?.device?.filter((d) => d.id === selectedValue.value)?.[0]
    const deviceParamsPromise = currentDevice?.registers ?? []
    const kpiParamsPromise = currentDevice?.kpis ?? []

    Promise.all([deviceParamsPromise, kpiParamsPromise])
      .then(([deviceParamsRes, kpiParamsRes]: any[]) => {
        const assetTypeId = deviceParamsRes
        const standardKPIs = kpiParamsRes
        const kpiParams = [...standardKPIs]

        const signalOptions2: Option[] = []

        assetTypeId.forEach((item: any) => {
          signalOptions2.push({
            value: item.cimCodeId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: false
          })
        })

        kpiParams.forEach((item: any) => {
          signalOptions2.push({
            value: item.kpiDefinitionId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: true
          })
        })

        setSignalOptions2(signalOptions2)
      })
      .catch((res: any) => {
        // Handle error
      })
  }

  const handleDeviceSelectionThirdClick = (selectedValue: Option): void => {
    setAssetLevelKPIEnabled3(false)
    setSelectedDevice2(selectedValue)
    setSignalData3(null)
    setSignalOptions3([])
    const currentDevice = GetDeviceParameters?.parameters?.gateway?.[0]?.device?.filter((d) => d.id === selectedValue.value)?.[0]
    const deviceParamsPromise = currentDevice?.registers ?? []
    const kpiParamsPromise = currentDevice?.kpis ?? []

    Promise.all([deviceParamsPromise, kpiParamsPromise])
      .then(([deviceParamsRes, kpiParamsRes]: any[]) => {
        const assetTypeId = deviceParamsRes
        const standardKPIs = kpiParamsRes
        const kpiParams = [...standardKPIs]

        const signalOptions3: Option[] = []
        assetTypeId.forEach((item: any) => {
          signalOptions3.push({
            value: item.cimCodeId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: false
          })
        })

        kpiParams.forEach((item: any) => {
          signalOptions3.push({
            value: item.kpiDefinitionId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: true
          })
        })

        setSignalOptions3(signalOptions3)
      })
      .catch((res: any) => {
        // Handle error
      })
  }

  const handleDeviceSelectionForthClick = (selectedValue: Option): void => {
    setAssetLevelKPIEnabled3(false)
    setSelectedDevice3(selectedValue)
    setSignalData4(null)
    setSignalOptions4([])
    const currentDevice = GetDeviceParameters?.parameters?.gateway?.[0]?.device?.filter((d) => d.id === selectedValue.value)?.[0]
    const deviceParamsPromise = currentDevice?.registers ?? []
    const kpiParamsPromise = currentDevice?.kpis ?? []

    Promise.all([deviceParamsPromise, kpiParamsPromise])
      .then(([deviceParamsRes, kpiParamsRes]: any[]) => {
        const assetTypeId = deviceParamsRes
        const standardKPIs = kpiParamsRes
        const kpiParams = [...standardKPIs]

        const signalOptions4: Option[] = []

        assetTypeId.forEach((item: any) => {
          signalOptions4.push({
            value: item.cimCodeId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: false
          })
        })

        kpiParams.forEach((item: any) => {
          signalOptions4.push({
            value: item.kpiDefinitionId,
            label: item.parameterName,
            unit: item.unit,
            isKPI: true
          })
        })

        setSignalOptions4(signalOptions4)
      })
      .catch((res: any) => {
        // Handle error
      })
  }

  const handleAsseKPIFirstClick = (selectedValue: Option, index: number): void => {
    setSignalData1(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: props.parentAssetId,
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleAsseKPISecondClick = (selectedValue: Option, index: number): void => {
    setSignalData2(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: props.parentAssetId,
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleAsseKPIThirdClick = (selectedValue: Option, index: number): void => {
    setSignalData3(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: props.parentAssetId,
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleAsseKPIForthClick = (selectedValue: Option, index: number): void => {
    setSignalData4(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: props.parentAssetId,
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleEditClick = (): void => {
    setIsEditing(true)
  }

  React.useEffect(() => {
    if (props.saveDefaultWidgetData?.DefaultWidgetData !== null && props.saveDefaultWidgetData?.DefaultWidgetData !== undefined) {
      selectedData.current = findWidget(props.saveDefaultWidgetData?.DefaultWidgetData, 'assetGraph2')
    } else {
      selectedData.current = null
      setConfigObject(defaultConfigObj)
    }
  }, [props.saveDefaultWidgetData?.DefaultWidgetData])

  const findWidget = (obj: any, widgetID: string): any => {
    const { assetDashBoardDefaultView } = obj
    const match = assetDashBoardDefaultView.find((widget: any) => widget?.widgetId === widgetID)
    return match !== undefined ? match : null
  }

  const getCimCode1 = (data: any, widgetId: string): void => {
    for (const widget of data?.assetDashBoardDefaultView ?? []) {
      if (widget?.widgetId === widgetId) {
        const deviceCimCodeIds = widget.devices.flatMap((device: any) => device.cimCodeIds.map((cimCodeId: string) => ({ id: device.deviceId, cimCodeId, index: device.index })))
        const deviceKpidefinitionIds = widget.devices.flatMap((device: any) => device.kpidefinitionIds.map((kpiId: string) => ({ id: device.deviceId, kpiId, index: device.index })))
        const assetKpidefinitionIds = (widget.assets !== undefined ? widget.assets.flatMap((asset: any) => asset.kpidefinitionIds.map((kpiId: string) => ({ id: asset.assetId, kpiId, index: asset.index }))) : [])
        const formattedDeviceCimCodeIds = deviceCimCodeIds.map((item: any) => ({
          Device: true,
          id: item.id,
          cimCodeId: item.cimCodeId,
          index: item.index
        }))
        const formattedDeviceKpidefinitionIds = deviceKpidefinitionIds.map((item: any) => ({
          Device: true,
          id: item.id,
          kpiId: item.kpiId,
          index: item.index
        }))
        const formattedAssetKpidefinitionIds = assetKpidefinitionIds.map((item: any) => ({
          Device: false,
          id: item.id,
          kpiId: item.kpiId,
          index: item.index
        }))
        setGraphDefaultSelectedIds([...formattedDeviceCimCodeIds, ...formattedDeviceKpidefinitionIds, ...formattedAssetKpidefinitionIds]?.map((e, i) => { return { ...e, index: e.index ?? i } })?.sort((a, b) => a.index - b.index))
      }
    }
  }

  const handleTextChange = (event: any): void => {
    const newValue = event.target.value
    setText(newValue)
    if (selectedData.current !== null) {
      selectedData.current = { ...selectedData.current, displayname: newValue }
    }
    updateTitleOnSaveDefaultObj(newValue, 'assetGraph2')
  }

  const updateTitleOnSaveDefaultObj = (title: string, widgetID: string): void => {
    const selectedDefaultData = {
      widgetId: widgetID,
      displayname: title,
      devices: [
        {
          deviceId: props.deviceIdCurrent,
          cimCodeIds: [],
          kpidefinitionIds: []
        }
      ],
      assets: []
    }
    updateSaveDefaultObject(saveDefaultViewObject, selectedData.current !== null ? selectedData.current : selectedDefaultData, widgetID)
  }

  const handleBlur = (): void => {
    setIsEditing(false)
  }

  const fetchDataForSelection = (updatedConfigObject: IConfigObject): void => {
    const { today, defaultDataWindowUTC } = getUtcDateRange()
    const formattedResponse = {
      assetId: props.parentAssetId,
      devices: Object.values(updatedConfigObject)
        .filter(item => item.selectedDeviceAssetID !== '' && item.checked)
        .map(item => ({
          deviceId: item.selectedDeviceAssetID,
          cimCodeIds: !item.isDeviceKPI && !item.isAssetKPI && (item.selectedSignalData != null) ? [item.selectedSignalData.value] : [],
          kpidefinitionIds: item.isDeviceKPI && (item.selectedSignalData != null) ? [item.selectedSignalData.value] : [],
          index: item.index
        })).filter((i: any) => i.cimCodeIds?.length > 0 || i.kpidefinitionIds?.length > 0)
    }

    const formattedResponseRegister = {
      assetId: props.parentAssetId,
      devices: Object.values(updatedConfigObject)
        .filter(item => item.selectedDeviceAssetID !== '' && item.checked)
        .map(item => ({
          deviceId: item.selectedDeviceAssetID,
          cimCodeIds: !item.isDeviceKPI && !item.isAssetKPI && (item.selectedSignalData != null) ? [item.selectedSignalData.value] : [],
          kpidefinitionIds: []
        })).filter((i: any) => i.cimCodeIds?.length > 0 || i.kpidefinitionIds?.length > 0)
    }

    const formattedResponseKPI = {
      assetId: props.parentAssetId,
      devices: Object.values(updatedConfigObject)
        .filter(item => item.selectedDeviceAssetID !== '' && item.checked)
        .map(item => ({
          deviceId: item.selectedDeviceAssetID,
          cimCodeIds: [],
          kpidefinitionIds: item.isDeviceKPI && (item.selectedSignalData != null) ? [item.selectedSignalData.value] : [],
          index: item.index
        })).filter((i: any) => i.cimCodeIds?.length > 0 || i.kpidefinitionIds?.length > 0),
      assets: Object.values(updatedConfigObject)
        .filter(item => item.isAssetKPI && (item.selectedSignalData != null) && item.checked)
        .map(item => ({
          assetId: props.parentAssetId,
          kpidefinitionIds: item.isAssetKPI && (item.selectedSignalData != null) ? [item.selectedSignalData.value] : [],
          index: item.index
        })).filter((i: any) => i.cimCodeIds?.length > 0 || i.kpidefinitionIds?.length > 0)
    }
    formattedResponseKPIRef.current = {
      assetId: props.parentAssetId,
      devices: [...formattedResponseRegister?.devices, ...formattedResponseKPI.devices],
      assets: [...formattedResponseKPI.assets]
    }

    props.getFlowRegisterService(props.startDate === '' ? defaultDataWindowUTC : props.startDate, props.endDate === '' ? today : props.endDate, 'assetGraph2', JSON.stringify(formattedResponseRegister), false)
    props.getFlowKPIService(props.startDate === '' ? defaultDataWindowUTC : props.startDate, props.endDate === '' ? today : props.endDate, 'assetGraph2', JSON.stringify(formattedResponseKPI), false)

    const selectedDefaultData: any = {
      widgetId: 'assetGraph2',
      displayname: text,
      devices: formattedResponse.devices,
      assets: formattedResponseKPI.assets
    }
    updateSaveDefaultObject(saveDefaultViewObject, selectedDefaultData, 'assetGraph2')
  }

  const handleSignalFirstClick = (selectedValue: Option, index: number): void => {
    setSignalData1(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: selectedDevice?.value ?? '',
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleSignalSecondClick = (selectedValue: Option, index: number): void => {
    setSignalData2(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: selectedDevice1?.value ?? '',
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleSignalThirdClick = (selectedValue: Option, index: number): void => {
    setSignalData3(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: selectedDevice2?.value ?? '',
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }
  const handleSignalForthClick = (selectedValue: Option, index: number): void => {
    setSignalData4(selectedValue)
    const newConfigObject = { ...configObject }
    newConfigObject[index] = {
      ...newConfigObject[index],
      selectedSignalData: selectedValue,
      selectedDeviceAssetID: selectedDevice3?.value ?? '',
      checked: true,
      isDeviceKPI: selectedValue.isKPI !== undefined ? selectedValue.isKPI : false,
      isAssetKPI: selectedValue.isAssetKPI !== undefined ? selectedValue.isAssetKPI : false,
      index
    }
    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleAllCheckboxClick = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setLoading(true)
    const isChecked = event.target.checked
    const updatedConfigObject = { ...configObject }
    setIsDefaultDataLoading(false)
    for (const key in updatedConfigObject) {
      if (Object.prototype.hasOwnProperty.call(updatedConfigObject, key)) {
        updatedConfigObject[key] = {
          ...updatedConfigObject[key],
          checked: isChecked,
          selectedSignalData: isChecked ? updatedConfigObject[key].selectedSignalData : null
        }
      }
    }

    // Reset the respective selectedDevice states based on the checkbox state
    if (!isChecked) {
      formattedResponseKPIRef.current = {
        assetId: props.parentAssetId,
        devices: [],
        assets: []
      }
      setSelectedDevice(null)
      setSelectedDevice1(null)
      setSelectedDevice2(null)
      setSelectedDevice3(null)
      setSignalOptions([])
      setSignalOptions1([])
      setSignalOptions2([])
      setSignalOptions3([])
      setSignalOptions4([])
    } else {
      // Restore selected devices if they were previously set
      setSelectedDevice(configObject[1]?.checked ? selectedDevice : null)
      setSelectedDevice1(configObject[2]?.checked ? selectedDevice1 : null)
      setSelectedDevice2(configObject[3]?.checked ? selectedDevice2 : null)
      setSelectedDevice3(configObject[4]?.checked ? selectedDevice3 : null)
    }

    setConfigObject(updatedConfigObject)
    fetchDataForSelection(updatedConfigObject)
  }

  const isAnySelectedSignalDataNull = (): boolean => {
    for (const key in configObject) {
      if (Object.prototype.hasOwnProperty.call(configObject, key)) {
        if (configObject[key].selectedSignalData === null) {
          return true
        }
      }
    }
    return false
  }

  const areAllChecked = (): boolean => {
    for (const key in configObject) {
      if (Object.prototype.hasOwnProperty.call(configObject, key)) {
        if (!configObject[key].checked) {
          return false
        }
      }
    }
    return true
  }

  const handleIndividualChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setLoading(true)
    setIsDefaultDataLoading(false)
    const { name, checked } = event.target
    const index = Number(name)
    const newConfigObject = { ...configObject }

    newConfigObject[index] = {
      ...newConfigObject[index],
      checked,
      selectedSignalData: checked ? newConfigObject[index].selectedSignalData : null
    }

    // Reset the respective selectedDevice state based on the checkbox index
    switch (index) {
      case 1:
        setSelectedDevice(checked ? selectedDevice : null)
        setSignalOptions1([])
        break
      case 2:
        setSelectedDevice1(checked ? selectedDevice1 : null)
        setSignalOptions2([])
        break
      case 3:
        setSelectedDevice2(checked ? selectedDevice2 : null)
        setSignalOptions3([])
        break
      case 4:
        setSelectedDevice3(checked ? selectedDevice3 : null)
        setSignalOptions4([])
        break
    }

    setConfigObject(newConfigObject)
    fetchDataForSelection(newConfigObject)
  }

  const handleclick = (): void => {
    setShowAddModal(true)
    props.stopInterval()
  }

  const handleOkandClose = (): void => {
    if (saveDefaultStatus.httpStatus === 201) {
      setshowSuccessPopUp(false)
    } else {
      setshowSuccessPopUp(false)
    }
  }

  const handleSaveDeafultGraphWithFailure = (): JSX.Element => {
    if (saveDefaultStatus.httpStatus === 201) {
      return (
        <Modal
          buttonTypeNegative='hollow'
          title={'Graph Default Status'}
          LabelPositive={'Ok'}
          onClickPositive={() => { handleOkandClose() }}
          onClose={() => { handleOkandClose() }}
        >
          <p style={{ paddingTop: '1.2em', fontSize: '18px' }}>
            {saveDefaultStatus.httpStatus === 201 ? 'Sucessfullly Updated' : saveDefaultStatus.loadingError}
          </p>
        </Modal>
      )
    } else if (saveDefaultStatus.isLoading) {
      return (
        <Modal title={'Loading...'}>
          <div className='CircularprogressAmi'>
            <CircularProgress />
          </div>
        </Modal>
      )
    } else if (saveDefaultStatus.httpStatus === 400) {
      return (
        <Modal buttonTypeNegative='hollow'
          title={'Graph Default Status'}
          LabelPositive={'Ok'}
          onClickPositive={() => { handleOkandClose() }}
          onClose={() => { handleOkandClose() }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {saveDefaultStatus.loadingError}
          </p>
        </Modal>
      )
    } else if (saveDefaultStatus.httpStatus === 401) {
      return (
        <div className='authError'><AuthError errorMessage='Unauthorized' /></div>
      )
    } else if (saveDefaultStatus.httpStatus === 403) {
      return (
        <div className='authError'><AuthError errorMessage='accessForbidden' /></div>
      )
    } else {
      return (
        <Modal
          buttonTypeNegative='hollow'
          title={'Graph Default Status'}
          LabelPositive={'Ok'}
          onClickPositive={() => {
            setshowSuccessPopUp(false)
          }}
          onClose={() => {
            setshowSuccessPopUp(false)
          }}
        >
          <p style={{ paddingTop: '1.2em' }}>
            {saveDefaultStatus.loadingError}
          </p>
        </Modal>
      )
    }
  }

  DarkUnica(HighCharts)
  return (
        <>
          <Grid container spacing={2}>
          <Grid item xs={12}>
          <Card className="device-dashboard-card" style={{ height: '480px' }}>
            <Card className="admin-card-titles device-card-title">
              <Grid container spacing={2} style={{ }}>
                <Grid item xs={7}>
                <Grid item xs={7} style={{ display: 'flex' }}>
                 {isEditing
                   ? (
                    <TextField
                      value={text}
                      onChange={handleTextChange}
                      onBlur={handleBlur}
                      autoFocus
                      variant="outlined"
                      size="small"
                      sx={{ input: { color: '#f0f0f0' } }}
                    />
                     )
                   : (
                    <Typography className='title-box' sx={{ color: '#f0f0f0' }}>{text}</Typography>
                     )}
                   <IconButton onClick={handleEditClick} size="small" sx={{ color: '#f0f0f0', marginLeft: '15px', marginTop: '-6px' }}>
                    <img src={EditIcon} />
                  </IconButton>
                </Grid>
                </Grid>
                <Grid item xs={5} className="align-text-right">
                <div className='graphHeader' style={{ display: 'flex' }}>
                  <span ><img src={extentWindow} style={{ cursor: 'pointer', marginTop: '-6px', width: '50px', height: '50px' }} onClick={handleclick}></img></span>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                    <div className="chart-container">
                      {getSignalGraph(0)}
                    </div>
                </Grid>
              </Grid>
            </Card>
          </Card>
        </Grid>
          </Grid>
          { showAddModal && <Modal title='' width='96%' height='auto'>
      <Grid container spacing={1}>
                <Grid item xs={12}>
                <div className='extend-window-title-div'><Typography className='extend-window-title'>Parameter Trends</Typography></div>
                <div className='C-datePicke' style={{ float: 'right', marginTop: '-20px', marginRight: '10px' }}>
                      <MemorizedExport
                        startDateTime={props.startDate === '' ? defaultDataWindowUTC : props.startDate}
                        endDateTime={props.endDate === '' ? today : props.endDate}
                        type={'asset'}
                        requestParameter={formattedResponseKPIRef.current ?? {
                          assetId: props.parentAssetId,
                          devices: selectedData.current?.devices ?? [],
                          assets: selectedData.current?.assets ?? []
                        }} />
                      <span style={{ marginTop: '15px', cursor: 'pointer', position: 'absolute' }} onClick={() => { setShowAddModal(false); props.startInterval() }}><CloseIcon/></span>
                </div>
                </Grid>
                <Grid item xs={12}>
                    <div className="chart-container" style={{ height: '280px' }}>
                     {getSignalGraph(1)}
                    </div>
                    <div className='chart-title-heading' style={{ textAlign: 'center' }}>
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className='set-Parameter' style={{ textAlign: 'center', marginTop: '80px' }}>
                    <Box className='register-table' p={3}>
                        <Typography variant="h6" style={{ float: 'left', fontFamily: 'Honeywell Sans Web' }}>
                          PARAMETER SETTING
                        </Typography>
                        <Grid container spacing={2} alignItems="left">
                          <Grid item xs={1}>
                            <Checkbox className='parameter-checkbox-head' checked={areAllChecked()} onChange={handleAllCheckboxClick} disabled={isAnySelectedSignalDataNull() || loading} style={{ color: '#D0D0D0' }}/>
                          </Grid>
                          <Grid item xs={1}>
                            <Typography className='table-title'>Colour</Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography className='table-title'>KPI Level</Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography className='table-title'>Devices</Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography className='table-title'>Parameters</Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography className='table-title'>Unit</Typography>
                          </Grid>
                            <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                                <Checkbox checked={configObject[1].checked} onChange={handleIndividualChange} name="1" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[1].selectedSignalData === null || loading}/>
                              </Grid>
                              <Grid item xs={1}>
                                <Checkbox style={{ color: colors[0], backgroundColor: colors[0], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select KPI Level"
                                    disabled={loading}
                                    value={selectedKPI1}
                                    options={selectedKPIOptions}
                                    onSelect={(e) => {
                                      setIsDefaultDataLoading(false)
                                      handleKPIClickFirst(e)
                                    }}
                                    width={200}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select Device"
                                    value={selectedDevice}
                                    options={selectedDeviceOptions}
                                    onSelect={(selectedValue: Option) => {
                                      resetSignalData(selectedDevice, selectedValue, 1)
                                      handleDeviceSelectionFirstClick(selectedValue)
                                    }}
                                    width={200}
                                    disabled={selectedKPI1?.value === 'assetLevel' || loading}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                              <GenXDropdown
                                        placeholder={'Select Signal'}
                                        disabled={loading}
                                        value={configObject[1].selectedSignalData}
                                        options={ isAssetLevelKPIEnabled1 ? assetKPIOptions : signalOptions1 }
                                        onSelect={isAssetLevelKPIEnabled1 ? (selectedValue) => { handleAsseKPIFirstClick(selectedValue, 1) } : (selectedValue) => { handleSignalFirstClick(selectedValue, 1) }}
                                        width={200}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                              <Typography>{configObject[1].selectedSignalData?.unit ?? '--'}</Typography>
                              </Grid>
                            </Grid>
                            <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                              <Checkbox checked={configObject[2].checked} onChange={handleIndividualChange} name="2" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[2].selectedSignalData === null || loading}/>
                              </Grid>
                              <Grid item xs={1}>
                                <Checkbox style={{ color: colors[1], backgroundColor: colors[1], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select KPI Level"
                                    disabled={loading}
                                    value={selectedKPI2}
                                    options={selectedKPIOptions}
                                    onSelect={(e) => {
                                      setIsDefaultDataLoading(false)
                                      handleKPIClickSecond(e)
                                    }}
                                    width={200}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select Device"
                                    value={selectedDevice1}
                                    options={selectedDeviceOptions}
                                    onSelect={(selectedValue: Option) => {
                                      resetSignalData(selectedDevice1, selectedValue, 2)
                                      handleDeviceSelectionSecondClick(selectedValue)
                                    }}
                                    width={200}
                                    disabled={selectedKPI2?.value === 'assetLevel' || loading}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                              <GenXDropdown
                                        placeholder={'Select Signal'}
                                        disabled={loading}
                                        value={configObject[2].selectedSignalData}
                                        options={ isAssetLevelKPIEnabled2 ? assetKPIOptions : signalOptions2 }
                                        onSelect={isAssetLevelKPIEnabled2 ? (selectedValue) => { handleAsseKPISecondClick(selectedValue, 2) } : (selectedValue) => { handleSignalSecondClick(selectedValue, 2) }}
                                        width={200}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                              <Typography>{configObject[2].selectedSignalData?.unit ?? '--'}</Typography>
                              </Grid>
                            </Grid>
                            <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                                <Checkbox checked={configObject[3].checked} onChange={handleIndividualChange} name="3" className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[3].selectedSignalData === null || loading}/>
                              </Grid>
                              <Grid item xs={1}>
                                <Checkbox style={{ color: colors[2], backgroundColor: colors[2], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select KPI Level"
                                    disabled={loading}
                                    value={selectedKPI3}
                                    options={selectedKPIOptions}
                                    onSelect={(e) => {
                                      setIsDefaultDataLoading(false)
                                      handleKPIClickThird(e)
                                    }}
                                    width={200}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select Device"
                                    value={selectedDevice2}
                                    options={selectedDeviceOptions}
                                    onSelect={(selectedValue: Option) => {
                                      resetSignalData(selectedDevice2, selectedValue, 3)
                                      handleDeviceSelectionThirdClick(selectedValue)
                                    }}
                                    width={200}
                                    disabled={selectedKPI3?.value === 'assetLevel' || loading}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                              <GenXDropdown
                                        placeholder={'Select Signal'}
                                        disabled={loading}
                                        value={configObject[3].selectedSignalData}
                                        options={ isAssetLevelKPIEnabled3 ? assetKPIOptions : signalOptions3}
                                        onSelect={isAssetLevelKPIEnabled3 ? (selectedValue) => { handleAsseKPIThirdClick(selectedValue, 3) } : (selectedValue) => { handleSignalThirdClick(selectedValue, 3) }}
                                        width={200}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                              <Typography>{configObject[3].selectedSignalData?.unit ?? '--'}</Typography>
                              </Grid>
                            </Grid>
                            <Grid className='table-container-data' container spacing={2} alignItems="left">
                            <Grid item xs={1}>
                                <Checkbox checked={configObject[4].checked} onChange={handleIndividualChange} name="4"className='parameter-checkbox' style={{ color: '#D0D0D0' }} disabled={configObject[4].selectedSignalData === null || loading}/>
                              </Grid>
                              <Grid item xs={1}>
                                <Checkbox style={{ color: colors[3], backgroundColor: colors[3], borderRadius: '0px', height: '20px', width: '20px', marginTop: '13px' }} disabled />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select KPI Level"
                                    disabled={loading}
                                    value={selectedKPI4}
                                    options={selectedKPIOptions}
                                    onSelect={(e) => {
                                      setIsDefaultDataLoading(false)
                                      handleKPIClickFourth(e)
                                    }}
                                    width={200}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                                 <GenXDropdown
                                    placeholder="Select Device"
                                    value={selectedDevice3}
                                    options={selectedDeviceOptions}
                                    onSelect={(selectedValue: Option) => {
                                      resetSignalData(selectedDevice3, selectedValue, 4)
                                      handleDeviceSelectionForthClick(selectedValue)
                                    }}
                                    width={200}
                                    disabled={selectedKPI4?.value === 'assetLevel' || loading}
                                  />
                              </Grid>
                              <Grid item xs={2}>
                                  <GenXDropdown
                                        placeholder={'Select Signal'}
                                        disabled={loading}
                                        value={configObject[4].selectedSignalData}
                                        options={ isAssetLevelKPIEnabled4 ? assetKPIOptions : signalOptions4}
                                        onSelect={isAssetLevelKPIEnabled4 ? (selectedValue) => { handleAsseKPIForthClick(selectedValue, 4) } : (selectedValue) => { handleSignalForthClick(selectedValue, 4) }}
                                        width={200}
                                    />
                              </Grid>
                              <Grid item xs={2}>
                              <Typography>{configObject[4].selectedSignalData?.unit ?? '--'}</Typography>
                              </Grid>
                            </Grid>
                        </Grid>
                      </Box>
                    </div>
                </Grid>
              </Grid>
      </Modal>
      }
      {showSuccessPopUp && handleSaveDeafultGraphWithFailure()}
        </>
  )
}
interface DispatchToProps {
  resetFuelService: () => void
  getFlowRegisterService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getFlowKPIService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => void
  getSaveDeafaultWidget: (siteId: string, parentAssetId: string, deviceIds: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  resetFuelService: () => { dispatch(flowRegisterGraphDataLoadingAction()); dispatch(flowKPIGraphDataLoadingAction()) },
  getFlowRegisterService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getFlowRegisterService(startDate, endDate, graphName, requestParams, isdefault)),
  getFlowKPIService: (startDate: string, endDate: string, graphName: string, requestParams: any, isdefault: boolean) => dispatch(getFlowKPIService(startDate, endDate, graphName, requestParams, isdefault)),
  getSaveDeafaultWidget: (siteId: string, parentAssetId: string, deviceIds: string) => dispatch(getSaveDeafaultWidget(siteId, parentAssetId, deviceIds))
})

interface StateToProps {
  flowSignalReadingData: flowSignalReadingAssetDataState
  saveDefaultWidgetData: GetDefaultWidgetDataState
  flowKPIAssetData: flowKPIAssetDataState
  flowRegisterData: flowRegisterAssetDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  flowSignalReadingData: state.FlowSignaGraphDataAssetDashboard,
  saveDefaultWidgetData: state.saveDefaultWidgetData,
  flowKPIAssetData: state.flowKPIAssetData,
  flowRegisterData: state.flowRegisterData
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface currentDeviceID {
  deviceIdCurrent: string
  assetTypeID: string
  startDate: string
  endDate: string
  Golive: boolean
  IsGolive: boolean
  stopInterval: any
  startInterval: any
  parentAssetId: string
  parentSiteId: string
}

type AllProps = PropsFromRedux & currentDeviceID

export const MemoFuelFlowGraph = React.memo(connector(fuelFlowGraph))
